import { render, staticRenderFns } from "./AppointmentPreview.vue?vue&type=template&id=7c4f2ffd&"
import script from "./AppointmentPreview.vue?vue&type=script&lang=js&"
export * from "./AppointmentPreview.vue?vue&type=script&lang=js&"
import style0 from "./AppointmentPreview.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports